import { motion, useScroll, useSpring, useTransform, useMotionTemplate } from "framer-motion";

export default function ScrollLight() {
  const { scrollYProgress } = useScroll();
  const rawX = useTransform(scrollYProgress, [0, 0.2, 0.4, 0.6, 0.8, 1], [72, 22, 68, 26, 64, 50]);
  const rawY = useTransform(scrollYProgress, [0, 1], [30, 70]);
  const x = useSpring(rawX, { stiffness: 30, damping: 20, mass: 1.2 });
  const y = useSpring(rawY, { stiffness: 30, damping: 20, mass: 1.2 });
  const background = useMotionTemplate`radial-gradient(ellipse 42% 34% at ${x}% ${y}%, rgba(197,160,89,0.11), rgba(197,160,89,0.03) 45%, transparent 72%)`;

  return (
    <motion.div
      aria-hidden
      style={{ background }}
      className="fixed inset-0 z-[1] pointer-events-none mix-blend-screen"
      data-testid="scroll-light"
    />
  );
}
